import type { FaireProductEntity } from "../../entity_types/product";

export const p_zmtpk6urpp: FaireProductEntity = {
  token: "p_zmtpk6urpp",
  type: "product",
  name: "Colorful Irregular Single Acrylic Bracelets DP25B570",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/1dba0fbe7805cf18c03a8d0f2792648592f75cb1945337218287c2f1626d6348.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4cd912ece6c793e1809e365e33988c6a8387ba0fed6f6090d5641999605ae91.jpeg",
    "https://cdn.faire.com/fastly/7fc4d2d9acfee04168603bad965e7c69bbf6a01413bcb50795d9a4aded1258d6.jpeg",
    "https://cdn.faire.com/fastly/1e8e2abaafcd7e3194ddd017b1969351955023b754748f66b06401e4f903e74a.jpeg",
    "https://cdn.faire.com/fastly/25d3dea21c6216fbdb2b7d43e8181f70feb1178cb2fea534e7cab284a885bb61.jpeg",
    "https://cdn.faire.com/fastly/3bedb2b20446b32a7a1c06c2839077721b95ca740b5f940c13445bb5b57a5228.jpeg",
    "https://cdn.faire.com/fastly/4cdc93b74c947631e1c3182ec1d3800d461c4fdb0e11ebbba40aa0d648089381.jpeg",
    "https://cdn.faire.com/fastly/e3b552b951606c4d8ef1c27d59830ec8dbd4b8314cbb0ee20e332fe62b37d591.jpeg",
    "https://cdn.faire.com/fastly/5efe045b57c992e4b548a5e316ebb90bf676448c96693d07d51a1c6a9b18ea3b.jpeg",
    "https://cdn.faire.com/fastly/37d641157e3eea8ea46fb1b4e1500691798bc90b709f631a07e1a6e45e8cd9c2.jpeg",
    "https://cdn.faire.com/fastly/880347fb63b416f967ae65367c99086b5f0b5666c5e0c7fc620998c08f0c2b22.jpeg",
    "https://cdn.faire.com/fastly/8849000a1586d18d5aa0e6e76ebd1119813cf81139791258d7f4ea5b8d6183af.jpeg",
    "https://cdn.faire.com/fastly/055fc1ce588f7024f81db14282cbfd166254d0e8ee0b3b893fe959defbfa1cc4.jpeg",
    "https://cdn.faire.com/fastly/adfe19e5797953931d5e280faf7ce2ed00694df11d2ba3e7d9643735b98ea8f5.jpeg",
    "https://cdn.faire.com/fastly/aa3aeb628c210572181b355f6e43652c6fbeefe10f7c79cc6b92a7eb280762d9.jpeg",
    "https://cdn.faire.com/fastly/a5b903f2e523f2712c5729f57ead315aba5ccff5dc0432979a8ef4e685a5ee67.jpeg",
    "https://cdn.faire.com/fastly/0acced8b332c8a0748c28025d2e56a0c2b9963662cab7e57b29271d0aade0c31.jpeg",
    "https://cdn.faire.com/fastly/fbb0ba247e08b28957ba9e4075df8974b3d774a4d4e3c6f1676bef5fb0e7c6b9.jpeg",
    "https://cdn.faire.com/fastly/83ec5331c0e5bd02f45f7530553d4c01ea8e5a9c84f38ce9e53c8673ed8d184c.jpeg",
    "https://cdn.faire.com/fastly/9ada765a4b13abcacb8a0d928e30701e5c4053de77ffd05f471b0509eb232ef0.jpeg",
    "https://cdn.faire.com/fastly/33bdab3877cc2470504e421f2a4dd3a9debde4b49a1b4e18b2624b99eff9a74d.jpeg",
    "https://cdn.faire.com/fastly/49ff612d462d8c428c438c07a8e6993c05ee81ea563d82adf31368ad6691f63c.jpeg",
    "https://cdn.faire.com/fastly/e9bf7ab2863e19a69e12e6771d3cacdfc837efc78cb3e67c039ab8d9f222679e.jpeg"
  ],
  priceDollars: 4.84,
  description: "Feature:\n * Colorful \n * Irregular \n * Layered Wear\n * Marbling Patterns\n * Smooth Surface\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 60g\n\n Material:\n * Acrylic\n\n Package:\n * Package include 1 bracelet.\n\n Note:\n * Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n * Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product.",
  tags: [],
  msrpDollars: 9.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:01.553Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
